<template>
  <teleport v-if="isOpen" to="body">
    <a-focus-trap initial-focus=".popup-share__button-close">
      <div class="popup-share">
        <section
          :id="`popup-share-${id}`"
          class="popup-share__popup"
          role="dialog"
          aria-labelledby="share-label"
          @keydown.esc="close"
        >
          <button class="popup-share__button-close" @click="close">
            <dpc-icon
              class="popup-share__icon-close"
              icon="close"
              label-path="close"
            ></dpc-icon>
          </button>

          <slot />
        </section>
        <div class="popup-share__overlay" @click="close"></div>
      </div>
    </a-focus-trap>
  </teleport>
</template>

<script setup>
import { toRefs, watch } from 'vue';

const props = defineProps({
  id: {
    type: String,
  },
  isOpen: {
    type: Boolean,
    default: false,
  },
});

const { id, isOpen } = toRefs(props);

const emit = defineEmits('close');

const close = () => {
  emit('close');
};

watch(isOpen, isOpen => {
  const html = document.querySelector('html');
  html.classList[isOpen ? 'add' : 'remove']('is-locked-by-dpc-popup-share');
});
</script>
